<template>
    <div>
        <div class="topic-label">
            <span class="label-type">{{ setQuestionType(item) }}</span>
            <div class="label-tit">{{ item.questionContent }}</div>
        </div>
        <el-checkbox-group v-model="checkedValues" class="option-group" :disabled="submitted">
            <div class="option-row" v-for="(opt, optIndex) in item.optionMapList" :key="'c-' + optIndex">
                <el-checkbox :label="opt.value">{{ opt.label }}</el-checkbox>
            </div>
        </el-checkbox-group>
        <div class="item-answer" v-if="!item.submitted">
            <el-button type="primary" @click="submit(item)"  :disabled="submitted">查看答案</el-button>
        </div>
    </div>
</template>

<script> 
import { getQuestionTypeLabel } from './topicQuestionTypes.js';
export default {
    name: 'TopicAnswerMultiple',
    props: {
        item: { type: Object, required: true },
    },
    data(){
        return {
            checkedValues:[],
            submitted:false,
        }
    },
    methods: {
        setQuestionType:getQuestionTypeLabel,
        submit(){
            if(this.checkedValues.length==0){
                this.$message.warning('请选择答案～');
                return;
            }
            let params={
                id:this.item.id,
                answer:this.checkedValues.join(''),
                questionFlag:'',
            }
            this.submitted=true;
            this.$emit('submitAnswer',params) 
        }
    },
};
</script>

<style lang="less" scoped>
@import './topic-info.less';
</style>
